<div class="container-fluid grading-page">
  <div class="row">
    <div class="col-12 grading-page__content">

      <div class="user-list-cbt ace-list-page">
        <div class="user-list-header ace-list-header">
          <div class="bread-crumbs project-font">
            <span class="users-title ace-list-title">{{ 'Learner Results' | aceTranslate }}</span>
          </div>
          <div class="header-actions ace-list-actions">
            <app-button
              class="ace-header-back-button"
              buttonType="button"
              buttonMainStyle="normal-btn-border"
              [buttonText]="'Back' | aceTranslate"
              (btnClick)="goBack()">
            </app-button>
            <app-breadcrumb
              [items]="[
                { label: ((isFromCorrections ? correctionsListTitleKey : listTitleKey) | aceTranslate), url: isFromCorrections ? correctionsBasePath : basePath },
                { label: detailBreadcrumbLabel, url: (isFromCorrections ? correctionsBasePath : basePath) + '/' + assessmentId },
                { label: ('Learner Results' | aceTranslate) }
              ]">
            </app-breadcrumb>
          </div>
        </div>
      </div>

      <div *ngIf="errorMessage" class="alert alert-danger alert-dismissible grading-page__alert" role="alert">
        {{ errorMessage }}
        <button type="button" class="btn-close" (click)="errorMessage = null"></button>
      </div>
      <div *ngIf="successMessage" class="alert alert-success alert-dismissible grading-page__alert" role="alert">
        {{ successMessage }}
        <button type="button" class="btn-close" (click)="successMessage = null"></button>
      </div>
      <div *ngIf="submissionDetailsPartiallyUnavailable" class="alert alert-warning grading-page__alert" role="alert">
        {{ 'Some submission details could not be loaded. Available grading data is still shown.' | aceTranslate }}
      </div>
      <div *ngIf="result?.hasNewerInProgressAttempt && result?.activeAttemptWarning" class="alert alert-warning grading-page__alert" role="alert">
        {{ result?.activeAttemptWarning | aceTranslate }}
      </div>

      <div *ngIf="isLoading" class="text-center py-5 text-muted">{{ 'Loading submission...' | aceTranslate }}</div>

      <ng-container *ngIf="!isLoading && result">
        <section class="grading-shell mb-4">
          <!-- <div class="grading-shell__toolbar">
            <app-button
              buttonType="button"
              buttonMainStyle="normal-btn-border"
              [buttonText]="'Back' | aceTranslate"
              (btnClick)="goBack()">
            </app-button>
          </div> -->

          <div class="grading-shell__panel">
            <div class="grading-shell__panel-header">
              <span
                class="grading-shell__panel-label"
                [class.grading-shell__panel-label--with-alert]="result.cheated">
                {{ 'Learner Results' | aceTranslate }}
              </span>
              <div *ngIf="result.cheated" class="grading-attempt-flag grading-attempt-flag--danger">
                {{ 'CHEATING ATTEMPT DETECTED' | aceTranslate }}
              </div>
            </div>

            <div class="grading-overview">
              <div class="grading-overview__content">
                <div class="grading-overview__intro">
                  <div class="grading-overview__eyebrow">{{ assessmentTypeLabel }}</div>
                  <h2 class="grading-overview__title">
                    {{ 'Submission - Attempt' | aceTranslate }} {{ result.attemptNumber ?? 1 }}
                  </h2>
                  <p *ngIf="result.learnerDisplayNameEn || result.learnerDisplayNameNative" class="grading-overview__learner mb-0">
                    <i class="mdi mdi-account-outline me-1"></i>
                    {{ result.learnerDisplayNameEn }}
                    <span *ngIf="result.learnerDisplayNameNative" class="text-secondary">
                      ({{ result.learnerDisplayNameNative }})
                    </span>
                  </p>
                  <p class="grading-overview__copy mb-0">
                    {{ (isReleasedOfficialResult
                        ? 'Admin has released the final result. The scoring shown below follows the selected official marker review.'
                        : 'Review answers, validate scoring, and submit your marker review from one place.') | aceTranslate }}
                  </p>
                </div>

                <div class="grading-overview__aside">
                  <span class="grading-role-badge">
                    {{ markerRoleLabel }}
                  </span>
                </div>
              </div>

              <div class="grading-overview__meta-grid">
                <div class="grading-meta-card">
                  <span class="grading-meta-card__label">{{ 'Submitted' | aceTranslate }}</span>
                  <span class="grading-meta-card__value">{{ result.submittedAt | date:'short' }}</span>
                </div>

                <div class="grading-meta-card">
                  <span class="grading-meta-card__label">{{ 'Released' | aceTranslate }}</span>
                  <span class="grading-meta-card__value">{{ result.releasedAt ? (result.releasedAt | date:'short') : '—' }}</span>
                </div>

                <div class="grading-meta-card">
                  <span class="grading-meta-card__label">{{ 'Official Grade Source' | aceTranslate }}</span>
                  <span class="grading-meta-card__value">
                    {{ isReleasedOfficialResult ? officialSelectedMarkerName : markerRoleLabel }}
                  </span>
                </div>
              </div>

              <app-metric-cards [cards]="submissionMetricCards"></app-metric-cards>
            </div>
          </div>
        </section>

        <section *ngIf="homeworkInstructionAttachments.length > 0" class="grading-shell__panel mb-4">
          <div class="grading-shell__panel-header">
            <div>
              <span class="grading-shell__panel-label">{{ 'Homework' | aceTranslate }}</span>
              <h3 class="grading-shell__panel-title mb-0">{{ 'Homework Instructions' | aceTranslate }}</h3>
              <p class="grading-shell__panel-copy mb-0">
                {{ 'Instructor instructions and allowed learner submission formats for reference while grading.' | aceTranslate }}
              </p>
            </div>
          </div>

          <div class="grading-homework-info">
            <div
              *ngFor="let attachment of homeworkInstructionAttachments; trackBy: trackByHomeworkInstruction"
              class="grading-homework-info__item">
              <div class="grading-homework-info__file-row">
                <i [class]="attachment.filePath ? 'ri-file-line' : 'ri-information-line'" aria-hidden="true"></i>
                <div class="grading-homework-info__file-main">
                  <span class="grading-homework-info__file-name">
                    {{ attachment.fileName || ('Instruction Document' | aceTranslate) }}
                  </span>
                  <span *ngIf="attachment.marks != null" class="grading-homework-info__marks">
                    {{ attachment.marks }} {{ 'mark(s)' | aceTranslate }}
                  </span>
                </div>
                <app-button
                  *ngIf="attachment.filePath"
                  buttonType="button"
                  buttonMainStyle="normal-btn-border"
                  [buttonText]="'Open File' | aceTranslate"
                  (btnClick)="openMedia(attachment.filePath)">
                </app-button>
              </div>

              <div *ngIf="attachment.instructionsEn" class="grading-homework-info__section">
                <span class="grading-homework-info__label">{{ 'Instruction Text' | aceTranslate }}</span>
                <p class="grading-homework-info__text mb-0">{{ attachment.instructionsEn }}</p>
              </div>

              <div *ngIf="getAllowedSubmissionFormats(attachment).length" class="grading-homework-info__section">
                <span class="grading-homework-info__label">{{ 'Allowed Student Submission Formats' | aceTranslate }}</span>
                <div class="grading-homework-info__formats">
                  <span
                    *ngFor="let format of getAllowedSubmissionFormats(attachment)"
                    class="grading-chip grading-chip--soft">
                    {{ format }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section class="grading-shell__panel mb-4">
          <div class="grading-shell__panel-header">
            <div>
              <span class="grading-shell__panel-label">{{ 'Review Summary' | aceTranslate }}</span>
              <h3 class="grading-shell__panel-title mb-0">{{ 'Marker Feedback' | aceTranslate }}</h3>
              <p class="grading-shell__panel-copy mb-0">
                {{ (isReleasedOfficialResult
                    ? 'This is the final released grade and comment chosen by admin.'
                    : 'Learners only see the official released result after admin selection and release.') | aceTranslate }}
              </p>
            </div>
          </div>

          <div class="grading-summary-panel">
            <div *ngIf="isAlreadyFinalized" class="grading-summary-panel__warning">
              {{ (isReleasedOfficialResult
                  ? 'This learner result is now read only and shows the final grade released by admin.'
                  : 'Your review is already submitted. This case is now read only until an admin decision is released.') | aceTranslate }}
            </div>
            <div *ngIf="!isAlreadyFinalized && isCurrentMarkerSubmitted" class="grading-summary-panel__warning">
              {{ 'Your review has been submitted and is now read only until an admin decision is released.' | aceTranslate }}
              <span *ngIf="currentMarkerSubmittedAt">
                {{ 'Submitted' | aceTranslate }}: {{ currentMarkerSubmittedAt | date:'short' }}
              </span>
            </div>

            <div class="grading-summary-panel__scoreboard">
              <div class="grading-summary-panel__score-main">
                <span class="grading-summary-panel__score-label">{{ 'Current Grade' | aceTranslate }}</span>
                <span class="grading-summary-panel__score-value">
                  {{ liveOverallScoreDisplay }}
                </span>
              </div>

              <div class="grading-summary-panel__score-chips">
                <span *ngIf="optionalQuestionCount > 0" class="grading-chip grading-chip--soft">
                  {{ 'Optional Questions' | aceTranslate }}: {{ optionalQuestionCount }}
                </span>
                <span *ngIf="optionalQuestionCount > 0" class="grading-chip grading-chip--success">
                  {{ 'Optional Score' | aceTranslate }}: {{ optionalQuestionsLiveScore }} / {{ optionalQuestionMarks }}
                </span>
                <span *ngIf="liveBonusScore > 0" class="grading-chip grading-chip--warning">
                  {{ 'Bonus Score' | aceTranslate }}: {{ liveBonusScore }}
                </span>
                <span class="grading-chip grading-chip--neutral">
                  {{ 'Base Score' | aceTranslate }}: {{ liveBaseScore }} / {{ baseScoreTotalMarks }}
                </span>
              </div>
            </div>

            <div class="grading-summary-panel__comment">
              <label class="grading-summary-panel__field-label" *ngIf="!isReleasedOfficialResult">
                {{ 'Feedback' | aceTranslate }}
              </label>
              <ng-container *ngIf="!isReleasedOfficialResult; else officialCommentView">
                <app-input
                  [hasLabel]="false"
                  inputType="textarea"
                  [inputPlaceholder]="'Add feedback for this marker review' | aceTranslate"
                  [disabledInput]="isFinalizing || isAlreadyFinalized || isCurrentMarkerSubmitted"
                  rows="6"
                  name="feedbackDraft"
                  [(ngModel)]="feedbackDraft"
                  [ngModelOptions]="{ standalone: true }">
                </app-input>
              </ng-container>

              <ng-template #officialCommentView>
                <div class="grading-evidence grading-evidence--plain">
                  {{ visibleReviewComment || ('No official comment provided.' | aceTranslate) }}
                </div>
              </ng-template>
            </div>
          </div>
        </section>

        <div
          *ngFor="let row of rows; trackBy: trackByRow"
          class="grading-shell__panel mb-3"
          [class.grading-shell__panel--optional]="row.attemptQuestion.optionalQuestion">
          <div class="grading-question-header">
            <div class="grading-question-header__main">
              <div class="grading-question-header__title-row">
                <span class="grading-question-header__index">{{ 'Q' | aceTranslate }}{{ row.orderNum }}</span>
                <span *ngIf="row.question" class="grading-chip grading-chip--neutral">{{ row.question.type }}</span>
                <span *ngIf="row.question" class="grading-chip grading-chip--soft">{{ row.question.difficulty }}</span>
                <span *ngIf="row.attemptQuestion.optionalQuestion" class="grading-chip grading-chip--success grading-chip--optional">
                  {{ 'Optional Question' | aceTranslate }}
                </span>
              </div>
              <div class="grading-question-header__subline">
                {{ row.attemptQuestion.marks }} {{ 'mark(s)' | aceTranslate }}
              </div>
            </div>

            <span *ngIf="getLiveQuestionScore(row) != null" class="grading-chip grading-chip--success">
              {{ 'Scored' | aceTranslate }}: {{ getLiveQuestionScore(row) }}
            </span>
            <span *ngIf="getLiveQuestionScore(row) == null && row.response" class="grading-chip grading-chip--warning">
              {{ 'Pending' | aceTranslate }}
            </span>
            <span *ngIf="!row.response" class="grading-chip grading-chip--soft">
              {{ 'Unanswered (0)' | aceTranslate }}
            </span>
          </div>

          <div class="grading-question-body">
            <app-tab-view>
              <app-tab-panel [header]="'Display' | aceTranslate">
                <div *ngIf="row.question; else missingQuestionTpl" class="mb-3">
                  <label class="form-label text-muted small">{{ 'Question:' | aceTranslate }}</label>
                  <div
                    class="grading-display-surface"
                    [class.grading-display-surface--rich]="hasDisplayRichContent(row.question.questionTextEn)">
                    <app-grading-rich-content [html]="renderDisplayHtml(row.question.questionTextEn)"></app-grading-rich-content>
                  </div>
                </div>
                <ng-template #missingQuestionTpl>
                  <p class="text-muted mb-3 grading-card__question">
                    {{ 'Question ID' | aceTranslate }}: {{ row.attemptQuestion.questionBankItemId }}
                  </p>
                </ng-template>

                <ng-container *ngIf="!isInstructorEditableQuestionType(row.question?.type)">
                  <div class="mb-3" *ngIf="row.response">
                    <label class="form-label text-muted small">
                      {{ (isMultiSelectQuestion(row) ? 'Selected answers:' : 'Selected option:') | aceTranslate }}
                    </label>
                    <div
                      class="grading-display-surface"
                      [class.grading-display-surface--rich]="hasDisplayRichContent(getObjectiveAnswerDisplay(row))">
                      <app-grading-rich-content [html]="renderDisplayHtml(getObjectiveAnswerDisplay(row))"></app-grading-rich-content>
                    </div>
                  </div>
                  <div class="grading-card__auto-result">
                    <span [class.text-success]="getVisibleQuestionCorrectness(row.response)"
                      [class.text-danger]="row.response != null && getVisibleQuestionCorrectness(row.response) === false">
                      {{ (getVisibleQuestionCorrectness(row.response) ? 'Correct' : (row.response ? 'Incorrect' : 'Unanswered')) | aceTranslate }}
                    </span>
                    &nbsp;&middot;&nbsp;
                    <span>{{ 'Score' | aceTranslate }}: {{ getLiveQuestionScore(row) ?? 0 }}</span>
                  </div>
                </ng-container>

                <ng-container *ngIf="isInstructorEditableQuestionType(row.question?.type) && row.response">
                  <div class="mb-0">
                    <label class="form-label text-muted small">{{ "Learner's answer:" | aceTranslate }}</label>
                    <ng-container *ngIf="isMcqQuestion(row); else nonMcqLearnerAnswerTpl">
                      <ng-container
                        [ngTemplateOutlet]="mcqAnswerOptionsTpl"
                        [ngTemplateOutletContext]="{ row: row }">
                      </ng-container>
                    </ng-container>
                    <ng-template #nonMcqLearnerAnswerTpl>
                    <ng-container *ngIf="row.response.answerFilePath; else textAnswerTpl">
                      <div class="grading-evidence">
                        <app-button
                          buttonType="button"
                          buttonMainStyle="normal-btn-border"
                          [buttonText]="'Download Essay File' | aceTranslate"
                          (btnClick)="openMedia(row.response.answerFilePath)">
                        </app-button>
                      </div>
                    </ng-container>
                    <ng-template #textAnswerTpl>
                      <div
                        class="grading-display-surface"
                        [class.grading-display-surface--rich]="hasDisplayRichContent(isManualType(row.question?.type) ? row.response.answerText : getObjectiveAnswerDisplay(row))">
                        <div class="grading-answer-row" [class.grading-answer-row--with-badge]="row.question?.type === 'TRUE_FALSE' && getVisibleQuestionCorrectness(row.response) != null">
                          <div class="grading-answer-row__content">
                            <app-grading-rich-content [html]="renderDisplayHtml(isManualType(row.question?.type) ? (row.response.answerText || ('(no answer provided)' | aceTranslate)) : getObjectiveAnswerDisplay(row))"></app-grading-rich-content>
                          </div>
                          <span
                            *ngIf="row.question?.type === 'TRUE_FALSE' && getVisibleQuestionCorrectness(row.response) != null"
                            class="grading-mcq-option__tag grading-answer-row__badge"
                            [class.grading-mcq-option__tag--correct]="getVisibleQuestionCorrectness(row.response) === true"
                            [class.grading-mcq-option__tag--incorrect]="getVisibleQuestionCorrectness(row.response) === false">
                            {{ (getVisibleQuestionCorrectness(row.response) ? 'Correct' : 'Incorrect') | aceTranslate }}
                          </span>
                        </div>
                      </div>
                    </ng-template>
                    </ng-template>
                  </div>
                </ng-container>

                <ng-container *ngIf="isInstructorEditableQuestionType(row.question?.type) && !row.response">
                  <ng-container *ngIf="isMcqQuestion(row); else unansweredQuestionTpl">
                    <label class="form-label text-muted small">{{ 'Choices:' | aceTranslate }}</label>
                    <ng-container
                      [ngTemplateOutlet]="mcqAnswerOptionsTpl"
                      [ngTemplateOutletContext]="{ row: row }">
                    </ng-container>
                    <p class="text-muted mt-3 mb-0">{{ 'Learner did not answer this question. Score: 0 (auto).' | aceTranslate }}</p>
                  </ng-container>
                  <ng-template #unansweredQuestionTpl>
                    <p class="text-muted mb-0">{{ 'Learner did not answer this question. Score: 0 (auto).' | aceTranslate }}</p>
                  </ng-template>
                </ng-container>
              </app-tab-panel>

              <app-tab-panel [header]="'Grading' | aceTranslate">
                <ng-container *ngIf="!isInstructorEditableQuestionType(row.question?.type)">
                  <div class="grading-card__auto-result">
                    <span>{{ (isMultiSelectQuestion(row) ? 'Selected answers' : 'Selected option') | aceTranslate }}: {{ getObjectiveAnswerDisplay(row) }}</span>
                    &nbsp;&middot;&nbsp;
                    <span [class.text-success]="getVisibleQuestionCorrectness(row.response)"
                      [class.text-danger]="row.response != null && getVisibleQuestionCorrectness(row.response) === false">
                      {{ (getVisibleQuestionCorrectness(row.response) ? 'Correct' : (row.response ? 'Incorrect' : 'Unanswered')) | aceTranslate }}
                    </span>
                    &nbsp;&middot;&nbsp;
                    <span>{{ 'Score' | aceTranslate }}: {{ getVisibleQuestionScore(row.response) ?? 0 }}</span>
                  </div>
                </ng-container>

                <ng-container *ngIf="isInstructorEditableQuestionType(row.question?.type)">
                  <div *ngIf="isMcqQuestion(row)" class="mb-3">
                    <label class="form-label text-muted small">{{ 'Choices:' | aceTranslate }}</label>
                    <ng-container
                      [ngTemplateOutlet]="mcqAnswerOptionsTpl"
                      [ngTemplateOutletContext]="{ row: row }">
                    </ng-container>
                  </div>
                  <div *ngIf="!isManualType(row.question?.type) || !row.response" class="grading-edit-hint">
                    {{ 'This question can still be reviewed and graded manually, even if it was auto-graded or left unanswered.' | aceTranslate }}
                  </div>
                  <div *ngIf="canGrade(); else scoredReadOnly" class="row g-3 align-items-end grading-control-row">
                    <div class="col-md-4">
                      <label class="form-label">
                        {{ 'Score (max' | aceTranslate }} {{ row.attemptQuestion.marks }})
                      </label>
                      <input type="number" class="form-control form-control-sm grading-score-input"
                        [ngModel]="getQuestionScoreEdit(row)?.score ?? 0"
                        (ngModelChange)="updateQuestionScore(row, $event)"
                        [ngModelOptions]="{ standalone: true }"
                        [min]="0" [max]="row.attemptQuestion.marks" />
                      <div *ngIf="exceedsQuestionMarks(getScoreEditKey(row), row.attemptQuestion.marks)"
                        class="form-text text-danger">
                        {{ 'Score cannot be more than total marks for this question.' | aceTranslate }}
                      </div>
                    </div>
                    <div class="col-md-5 pt-4">
                      <div class="d-flex align-items-center gap-2 grading-ace-checkbox">
                        <app-input
                          [hasLabel]="false"
                          inputType="checkbox"
                          modeType="update"
                          [parentFormGroup]="getQuestionCorrectForm(row)"
                          parentFormControl="isCorrect">
                        </app-input>
                        <label class="form-label mb-0">{{ 'Mark as correct' | aceTranslate }}</label>
                      </div>
                    </div>
                  </div>
                  <ng-template #scoredReadOnly>
                    <p class="text-muted small mb-0 grading-readonly-result">
                      {{ 'Score' | aceTranslate }}: <strong>{{ getLiveQuestionScore(row) ?? 0 }}</strong> / {{ row.attemptQuestion.marks }}
                      &nbsp;&middot;&nbsp;
                      <span [class.text-success]="scoreEdits[getScoreEditKey(row)]?.isCorrect" [class.text-danger]="scoreEdits[getScoreEditKey(row)]?.isCorrect === false">
                        {{ ((scoreEdits[getScoreEditKey(row)]?.isCorrect ? 'Correct' : 'Incorrect')) | aceTranslate }}
                      </span>
                    </p>
                  </ng-template>
                </ng-container>
              </app-tab-panel>
            </app-tab-view>
          </div>
        </div>

        <div *ngIf="rows.length === 0 && fileResponses.length === 0"
             class="text-muted grading-empty-state">{{ 'No question responses found.' | aceTranslate }}</div>

        <ng-container *ngIf="fileResponses.length > 0">
          <section class="grading-shell__panel mb-3">
            <div class="grading-shell__panel-header">
              <div>
                <span class="grading-shell__panel-label">{{ 'Attachments' | aceTranslate }}</span>
                <h3 class="grading-shell__panel-title mb-0">{{ 'File Questions' | aceTranslate }}</h3>
              </div>
            </div>
          </section>

          <div *ngFor="let fr of fileResponses; let i = index; trackBy: trackByFileResponse" class="grading-shell__panel mb-3">
            <div class="grading-question-header">
              <div class="grading-question-header__main">
                <div class="grading-question-header__title-row">
                  <span class="grading-question-header__index">{{ 'File Q' | aceTranslate }}{{ i + 1 }}</span>
                  <span class="grading-chip grading-chip--neutral">{{ 'FILE' | aceTranslate }}</span>
                </div>
                <div class="grading-question-header__subline">
                  {{ getFileQuestionMaxMarks(fr) }} {{ 'mark(s)' | aceTranslate }} · {{ getAttachmentName(fr.homeworkAttachmentId) }}
                </div>
              </div>

              <span *ngIf="getVisibleFileScore(fr) != null" class="grading-chip grading-chip--success">
                {{ 'Scored' | aceTranslate }}: {{ getLiveFileScore(fr) }}
              </span>
              <span *ngIf="getVisibleFileScore(fr) == null" class="grading-chip grading-chip--warning">
                {{ 'Pending' | aceTranslate }}
              </span>
            </div>

            <div class="grading-question-body">
              <div class="mb-3">
                <label class="form-label text-muted small">{{ "Learner's answer:" | aceTranslate }}</label>
                <div class="grading-evidence">
                  <ng-container *ngIf="fr.answerFilePath; else noFileTpl">
                    <app-button
                      buttonType="button"
                      buttonMainStyle="normal-btn-border"
                      [buttonText]="'Download Answer File' | aceTranslate"
                      (btnClick)="openMedia(fr.answerFilePath)">
                    </app-button>
                  </ng-container>
                  <ng-template #noFileTpl>
                    <span class="text-muted">{{ '(no file submitted)' | aceTranslate }}</span>
                  </ng-template>
                </div>
              </div>

              <div *ngIf="canGrade(); else fileScoreReadOnly" class="row g-3 align-items-end grading-control-row">
                <div class="col-md-4">
                  <label class="form-label">
                    {{ 'Score (max' | aceTranslate }} {{ getFileQuestionMaxMarks(fr) }})
                  </label>
                  <input type="number" class="form-control form-control-sm grading-score-input"
                    [ngModel]="getFileScoreEdit(fr)?.score ?? 0"
                    (ngModelChange)="updateFileScore(fr, $event)"
                    [ngModelOptions]="{ standalone: true }"
                    [min]="0" [max]="getFileQuestionMaxMarks(fr)" />
                  <div *ngIf="exceedsFileQuestionMarks(fr.id, getFileQuestionMaxMarks(fr))"
                    class="form-text text-danger">
                    {{ 'Score cannot be more than total marks for this question.' | aceTranslate }}
                  </div>
                </div>
                <div class="col-md-5 pt-4">
                  <div class="d-flex align-items-center gap-2 grading-ace-checkbox">
                    <app-input
                      [hasLabel]="false"
                      inputType="checkbox"
                      modeType="update"
                      [parentFormGroup]="getFileCorrectForm(fr)"
                      parentFormControl="isCorrect">
                    </app-input>
                    <label class="form-label mb-0">{{ 'Mark as correct' | aceTranslate }}</label>
                  </div>
                </div>
              </div>
              <ng-template #fileScoreReadOnly>
                <p class="text-muted small mb-0 grading-readonly-result">
                  {{ 'Score' | aceTranslate }}: <strong>{{ getLiveFileScore(fr) ?? 0 }}</strong> / {{ getFileQuestionMaxMarks(fr) }}
                  &nbsp;&middot;&nbsp;
                  <span [class.text-success]="fr.isCorrect" [class.text-danger]="!fr.isCorrect">
                    {{ (fr.isCorrect ? 'Correct' : 'Incorrect') | aceTranslate }}
                  </span>
                </p>
              </ng-template>
            </div>
          </div>
        </ng-container>

        <div class="d-flex gap-2 justify-content-end mb-4">
          <app-button
            buttonType="button"
            buttonMainStyle="btn btn-danger"
            [buttonText]="'Cancel' | aceTranslate"
            (btnClick)="goBack()">
          </app-button>
          <app-button
            *ngIf="!isReleasedOfficialResult"
            buttonType="button"
            buttonMainStyle="btn btn-primary"
            [disabled]="isFinalizing || isAlreadyFinalized || isCurrentMarkerSubmitted || !canFinalize()"
            [buttonText]="submitButtonLabel | aceTranslate"
            (btnClick)="finalizeGrade()">
          </app-button>
        </div>
      </ng-container>

      <ng-template #mcqAnswerOptionsTpl let-row="row">
        <div class="grading-mcq-list" *ngIf="getMcqOptions(row).length; else missingMcqOptionsTpl">
          <div
            *ngFor="let option of getMcqOptions(row); let optionIndex = index; trackBy: trackByOption"
            class="grading-mcq-option"
            [class.grading-mcq-option--selected]="isMcqOptionSelected(row, option.id)"
            [class.grading-mcq-option--correct]="option.isCorrect">
            <div class="grading-mcq-option__stem">
              <span class="grading-mcq-option__letter">
                {{ ['A', 'B', 'C', 'D', 'E', 'F'][optionIndex] || (optionIndex + 1) }}
              </span>
            </div>
            <label class="grading-mcq-option__control">
              <input
                type="checkbox"
                class="form-check-input grading-mcq-option__checkbox"
                [checked]="isMcqOptionSelected(row, option.id)"
                disabled>
              <span class="grading-mcq-option__text">
                <app-grading-rich-content [html]="renderDisplayHtml(getMcqOptionText(option))"></app-grading-rich-content>
              </span>
            </label>
            <div class="grading-mcq-option__meta">
              <span *ngIf="isMcqOptionSelected(row, option.id)" class="grading-mcq-option__tag grading-mcq-option__tag--learner">
                {{ 'Learner answer' | aceTranslate }}
              </span>
              <span *ngIf="option.isCorrect" class="grading-mcq-option__tag grading-mcq-option__tag--correct">
                {{ 'Correct answer' | aceTranslate }}
              </span>
            </div>
          </div>
        </div>
      </ng-template>

      <ng-template #missingMcqOptionsTpl>
        <div class="grading-display-surface">
          {{ 'MCQ options could not be loaded.' | aceTranslate }}
        </div>
      </ng-template>
    </div>
  </div>
</div>
